import React, {Component} from 'react';
import classNames from 'classnames';
import {ShipContext} from './context/ShipContext';

class SubcategoryListItemWithSublists extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isListOpen: false
        };

        this.listItemRef = React.createRef();
        this.handleBtnClick = this.handleBtnClick.bind(this);
    }

    componentDidMount() {
        const isListOpen = this.props.subcategory.id === this.props.activeSubareaId;
        this.setState({isListOpen});
    }

    componentDidUpdate(prevProps, prevState) {
        const {
            isAreaActive,
            activeSubareaId,
            subcategory,
            checkIfShouldAddScroll
        } = this.props;

        if (activeSubareaId !== prevProps.activeSubareaId) {
            const isListOpen = subcategory.id === activeSubareaId;
            this.setState({isListOpen});
        }

        if (isAreaActive !== prevProps.isAreaActive) {
            this.setState({isListOpen: false});
        }

        if (this.state.isListOpen !== prevState.isListOpen) {
            checkIfShouldAddScroll();
        }
    }

    handleBtnClick() {
        const {
            subcategory,
            activeSubareaId,
            setActiveSubareaId,
            checkIfShouldAddScroll
        } = this.props;

        this.setState((prevState) => {
            return {isListOpen: !prevState.isListOpen}
        });

        if (subcategory.id === activeSubareaId) {
            setActiveSubareaId('');
        } else {
            setActiveSubareaId(subcategory.id);
        }

        checkIfShouldAddScroll();
    }

    scrollElementIntoView() {
        const
            element = this.listItemRef.current,
            elementOffsetTop = element.offsetTop,
            parentOffsetTop = element.parentNode.offsetTop;

        // Container with custom scroll created by Scrollbars component
        let scrollContainer = this.props.contentContainerRef.parentNode;

        // Checking if the container indeed has scroll enabled
        if (scrollContainer && scrollContainer.style.overflow === 'scroll') {
            scrollContainer.scrollTop = elementOffsetTop - parentOffsetTop;
        }
    }

    render() {

        let sublistClasses = classNames('area-categories__sublist', {'area-categories__sublist--open': this.state.isListOpen}),
            btnClasses = classNames('area-categories__dropdown-btn', {'area-categories__dropdown-btn--open': this.state.isListOpen});

        if (this.state.isListOpen) {
            this.scrollElementIntoView()
        }

        return (
            <li className="area-categories__item area-categories__item--has-sublist"
                ref={this.listItemRef}
            >
                <button className={btnClasses}
                        type="button"
                        onClick={this.handleBtnClick}
                >
                    {this.props.subcategory.displayName}
                </button>
                <ul className={sublistClasses}>
                    {this.props.subcategory.subareas.map(subcategory => this.props.constructSingleItem(subcategory))}
                </ul>
            </li>
        )
    }
}

function SubcategoryListItemWithSublistsWithContext(props) {
    return (
        <ShipContext.Consumer>
            {(context) =>
                <SubcategoryListItemWithSublists
                    setActiveSubareaId={context.setActiveSubareaId}
                    activeSubareaId={context.activeSubareaId}
                    {...props}
                />
            }
        </ShipContext.Consumer>
    )
}

export default SubcategoryListItemWithSublistsWithContext;